export const LIST_ITEM_TYPE_GROUP = 'group';
export const LIST_ITEM_TYPE_PROJECT = 'project';
export const COMPONENT_NAME = 'NestedGroupsProjectsList';
